import React, { useEffect, useState } from 'react';
import './ReviewCart.scss';
import { FxCurrency, useNavigationService , AlertService} from './../../fx-core';
import { useSelector, useDispatch } from 'react-redux';
import * as _ from 'lodash';
import { Divider } from '@material-ui/core';

export const ReviewCart = (props) => {
    const dispatch = useDispatch();
    const { navigate } = useNavigationService();

    const cartInfo = useSelector<any, any>(store => store.cart);
    const cart = cartInfo;

   const reduceQtyFromCart = (item) => {
  getModifierAmount(item);

  const minLimit = getMinLimit(item);
  const currentQty = Number(item?.quantity ?? 0);
  const nextQty = currentQty - 1;

  if (
    (typeof minLimit === 'number' && nextQty < minLimit) ||
    (typeof minLimit !== 'number' && nextQty < 0)
  ) {
    return;
  }

  dispatch({ type: "REDUCE_CART", payload: { stallId: props.stallId, item } });
};

const addQtyToCart = (item) => {
  getModifierAmount(item);

  const maxLimit = getEffectiveMax(item);
  const currentQty = Number(item?.quantity ?? 0);
  const nextQty = currentQty + 1;

  if (typeof maxLimit === 'number' && nextQty > maxLimit) {
    showWarn(`You can’t add more than ${maxLimit} for this item.`);
    return;
  }

  dispatch({ type: "ADD_CART", payload: { stallId: props.stallId, item } });
};


    const getModifierAmount = (item) => {
        if (item.customizedDetails && item.customizedDetails.length > 0) {
            let totalModifierAmt = _.sumBy(item.customizedDetails, 'stallItemCustomizeDetailPrice');
            item.modifierAmt = totalModifierAmt;
        }
    }

    // ---- limits helpers (same logic as StallItem) ----
const getMaxLimit = (item: any): number | undefined => {
  const max = Number(item?.maximumQuantity);
  return Number.isFinite(max) && max > 0 ? max : undefined;
};

const getMinLimit = (item: any): number | undefined => {
  const min = Number(item?.minimumQuantity);
  return Number.isFinite(min) && min >= 0 ? min : undefined;
};

// Cap by available stock too, if provided via currentQuantity
const getEffectiveMax = (item: any): number | undefined => {
  const maxLimit = getMaxLimit(item);
  const stock = Number(item?.currentQuantity);
  const stockCap = Number.isFinite(stock) && stock > 0 ? stock : undefined;
  if (typeof maxLimit === 'number' && typeof stockCap === 'number') return Math.min(maxLimit, stockCap);
  return typeof maxLimit === 'number' ? maxLimit : stockCap;
};

const showWarn = (msg: string) => {
  (AlertService as any)?.warn?.(msg);
};


    const backToStallItems = () => {
        let navData = {
            targetRoute: '/stalls/' + props.stallSlug,
            targetTitle: "Stall",
            targetData: {},
            sourceState: {},
            eventSource: '',
        };
        navigate(navData);
    };

    useEffect(() => {
    }, [cartInfo]);

    return (
        <div className="reviewcart-ui">
            <h3 className="cart-title">
                <span>Order Summary</span>
            </h3>

            <div className='row pt-2 pb-3'>
                <span className='col-7 text-right font-15 font-weight-bold'><u>{props.stallName}</u></span>
                <span className='col-5 text-right'>
                    <a className="link-btn font-13 px-2" onClick={backToStallItems}>Add More Items</a>
                </span>
            </div>
            <div className="cart-inner">
                <div className="cart-item m-0">
                    {
                        cart.items.length > 0 && cart.items.map((item, i) => (
                            <div className="row m-0 mb-2" key={i}>
                                <div className="col-md-8 col-6 px-1">
                                    <span className="cart-text text-truncate bold-text" title={item.itemName}>{item.itemName}</span>
                                    {
                                        item.groupedCustomDetails && item.groupedCustomDetails.length > 0 && item.groupedCustomDetails.map((custom, k) => (
                                            <div>
                                                <span className='color-txt font-11'>{custom.key} - </span>
                                                {
                                                    custom.displayModifiers.length > 0 && custom.displayModifiers.map((detail, idx) => (
                                                        <span className='color-txt font-11'>{detail.description}
                                                            {detail.price > 0 &&
                                                                <span> - <FxCurrency value={detail.price} /></span>
                                                            }
                                                            {idx != (custom.displayModifiers.length - 1) &&
                                                                <span>,</span>
                                                            }
                                                        </span>
                                                    ))
                                                }
                                                {k != (item.groupedCustomDetails.length - 1) &&
                                                    <span className='color-txt font-11'>,</span>
                                                }
                                            </div>
                                        ))
                                    }
                                </div>

                                <div className="col-6 col-md-4 px-1 d-flex align-items-center justify-content-between">
                                    {/* <div className="d-flex align-items-center justify-content-between" style={{ width: 80, height: 29 }}>
                                        <span className="count-minus pointer color-primary h-100 d-flex align-items-center justify-content-center" onClick={() => reduceQtyFromCart(item)} style={{ flex: 1 }}>
                                            <i className="fas fa-minus-square"></i>
                                        </span>
                                        <span className="quantity-count bl br d-flex align-items-center justify-content-center h-100 m-0 pointer"
                                            style={{ flex: 1 }}>{item.quantity}</span>
                                        <span className="count-plus pointer color-primary h-100 d-flex align-items-center justify-content-center" onClick={() => addQtyToCart(item)} style={{ flex: 1 }}>
                                            <i className="fas fa-plus-square"></i>
                                        </span>
                                    </div> */}


<div className="d-flex align-items-center justify-content-between" style={{ width: 80, height: 29 }}>
  {(() => {
    const qty = Number(item?.quantity ?? 0);
    const maxLimit = getEffectiveMax(item);
    const minLimit = getMinLimit(item);
    const atMax = typeof maxLimit === 'number' && qty >= maxLimit;
    const atMin = typeof minLimit === 'number' ? qty <= minLimit : qty <= 0;

    return (
      <>
        <span
          className={`count-minus pointer color-primary h-100 d-flex align-items-center justify-content-center ${atMin ? 'opacity-50' : ''}`}
          onClick={() => !atMin && reduceQtyFromCart(item)}
          style={{ flex: 1, ...(atMin ? { pointerEvents: 'none' } : {}) }}
          title={atMin ? 'Minimum quantity reached' : 'Decrease'}
        >
          <i className="fas fa-minus-square"></i>
        </span>

        <span
          className="quantity-count bl br d-flex align-items-center justify-content-center h-100 m-0"
          style={{ flex: 1 }}
        >
          {qty}
        </span>

        <span
          className={`count-plus pointer color-primary h-100 d-flex align-items-center justify-content-center ${atMax ? 'opacity-50' : ''}`}
          onClick={() => !atMax && addQtyToCart(item)}
          style={{ flex: 1, ...(atMax ? { pointerEvents: 'none' } : {}) }}
          title={atMax ? `Max ${maxLimit} reached` : 'Increase'}
        >
          <i className="fas fa-plus-square"></i>
        </span>
      </>
    );
  })()}
</div>
                                    <span className='font-14'>
                                        <FxCurrency value={item.totalPrice} />
                                    </span>
                                </div>
                            </div>
                        ))
                    }
                    {cart && cart.items.length == 0 &&
                        <div>No items in the cart</div>
                    }

                </div>
            </div>
            {cart && cart.totalAmount > 0 &&
                <div className="cart-footer">
                    <div className="row mb-2">
                        <div className="col-md-4 col-6">
                            <div className="sub-text">
                                <h6>Total</h6>
                            </div>
                        </div>
                        <div className="col-md-8 col-6 text-right">
                            <FxCurrency value={cart.totalAmount} />
                        </div>
                    </div>
                    {props.selectedCouponValue > 0 &&
            <>
                <div className="row mb-2">
                    <div className="col-md-4 col-6">
                        <div className="sub-text text-success">
                            <h6>Discount</h6>
                        </div>
                    </div>
                    <div className="col-md-8 col-6 text-right text-success">
                        - <FxCurrency value={props.selectedCouponValue} />
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-4 col-6">
                        <div className="sub-text">
                            <h6><strong>Net Total</strong></h6>
                        </div>
                    </div>
                    <div className="col-md-8 col-6 text-right">
                        <strong>
                            <FxCurrency value={Math.max(0, cart.totalAmount - props.selectedCouponValue)} />
                        </strong>
                    </div>
                </div>
            </>
        }
                    <a className="btn btn-block btn-xl text-white confirm-btn" onClick={props.confirmOrder}>Confirm
                        <span>&rarr;</span>
                    </a>
                </div>
            }
        </div>
    )
};